import React from 'react';

const PricingPage = () => {
  const pricingCategories = [
    {
      title: 'Basic Plan',
      description: 'Suitable for individuals with mild speech and language disorders.',
      price: '$49/month',
      features: [
        '2 therapy sessions per month',
        'Access to online resources',
        'Basic progress tracking',
      ],
    },
    {
      title: 'Standard Plan',
      description: 'Ideal for individuals with moderate speech and language disorders.',
      price: '$99/month',
      features: [
        '4 therapy sessions per month',
        'Access to online resources',
        'Detailed progress tracking',
        'Personalized exercises',
      ],
    },
    {
      title: 'Premium Plan',
      description: 'Comprehensive support for individuals with complex speech and language disorders.',
      price: '$199/month',
      features: [
        '8 therapy sessions per month',
        'Access to online resources',
        'Detailed progress tracking',
        'Personalized exercises',
        'Priority support',
      ],
    },
  ];

  return (
    <div className="bg-gray-100 min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-center mb-12">Pricing Plans</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pricingCategories.map((category, index) => (
            <div key={index} className="bg-white shadow-lg rounded-lg p-6">
              <h2 className="text-2xl font-bold mb-4">{category.title}</h2>
              <p className="text-gray-600 mb-6">{category.description}</p>
              <div className="text-4xl font-extrabold mb-6">{category.price}</div>
              <ul className="mb-8">
                {category.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center mb-2">
                    <svg
                      className="w-6 h-6 text-green-500 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <button className="bg-primary text-white py-2 px-6 rounded-md hover:bg-primary">
                Choose Plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPage;